/**
 * Home's landing helper. The one-time "This is your Home…" banner (RD-35) is not
 * shown yet: it fires on "Use this plan", which arrives with Plan's spec, and until
 * then Paul's H9 holds (no teaching on dev until the banner). Its "seen" state lives on
 * the account (`profile.home_intro_seen_at`), not in this browser.
 */
import type { DefaultView } from "@/api/profile";

/**
 * Where "Default view on open" lands with the redesign switch on. The setting kept its
 * three values so no account needs migrating: `dashboard` is Home now, and `budgets` is
 * Plan (Budgets is retired, Paul 2026-10-29).
 */
export function landingPathFor(view: DefaultView): string {
  if (view === "dashboard") return "/home";
  if (view === "budgets") return "/plan";
  return `/${view}`;
}
